export default "__VITE_ASSET__Dc8KrRK3__"